import React, { useState, useEffect } from 'react';
import "react-data-table-component-extensions/dist/index.css";
import { useDispatch, useSelector } from 'react-redux';
import { userListRes, userListTodo } from '../../LMS_Redux/LMS_Slices/Masters/UserList';
import PropagateLoader from "react-spinners/PropagateLoader";
import DataTables from '../LMS_DATA_TABLE/DataTable';
import UserListAction from '../LMS_DATA_TABLE/ActionButtons/UserList';
import { groupCountDataRes, groupCountDataTodo } from '../../LMS_Redux/LMS_Slices/Masters/GroupCountData';
import { useLocation } from 'react-router-dom';
import moment from 'moment';

export default function UserList() {

    const dispatch = useDispatch()
    const { state } = useLocation()
    const data = useSelector(state => state.userList && state.userList.data && state.userList.data.data)
    const group_data = useSelector(state => state.groupCountData && state.groupCountData.data && state.groupCountData.data.data)
    const [loading, setLoading] = useState(false)
    const [modalLoading, setModalLoading] = useState(false)
    const [groupList, setGroupList] = useState(false)
    // console.log(group_data)

    const group_details = (val) => {
        // console.log(val.data.group_ids)
        setModalLoading(true)
        setGroupList(true)
        dispatch(groupCountDataTodo(val.data.group_ids)).then(() => group_list_res())
    }

    const [columnDefs, setColumnDefs] = useState([
        {
            headerName: 'NAME',
            field: 'vemp_fname',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
            width: 300
        },
        {
            headerName: 'ID',
            field: 'vemp_company_code',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        // {
        //     headerName: 'DEPARTMENT',
        //     field: 'vdepartment_name',
        //     filter: 'agTextColumnFilter',
        //     suppressMenu: true,
        //     filter: true,
        //     sortable: true,
        //     floatingFilter: true,
        //     // wrapText: true,
        //     // autoHeight: true,
        // },
        {
            headerName: 'DESIGNATION',
            field: 'vdesignation_name',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
            minWidth: 150
        },
        {
            headerName: 'ROLE',
            field: 'vrole_name',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'GROUPS',
            field: 'group_count',
            cellRenderer: params => <span style={{ color: '#2262C6', cursor: 'pointer' }} onClick={() => group_details(params)}>{params.value}</span>,
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'EMAIL',
            field: 'vemail',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'PHONE NO.',
            field: 'vmobile_no',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'STATUS',
            field: 'vstatus',
            cellRenderer: params => params.value == 'Active' ? <span className='badge text-bg-success'>Active</span> : <span className='badge text-bg-danger'>Inactive</span>,
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            field: 'ACTIONS',
            cellRenderer: UserListAction,
            // cellRendererParams: {
            //     editModal: setEditVenue,
            //     modalLoading: setModalLoading,
            //     editForm: setEdit,
            // },
            // wrapText: true,
            autoHeight: true,
        }
    ]);

    const user_list_res = () => {
        if (userListRes && userListRes.success) {
            setLoading(false)
        } else {
            setLoading(false)
        }
    }

    const group_list_res = () => {
        if (groupCountDataRes && groupCountDataRes.success) {
            setModalLoading(false)
        } else {
            setModalLoading(false)
        }
    }

    useEffect(() => {
        setLoading(true)
        dispatch(userListTodo({ "role": state ? state : "" })).then(() => user_list_res())
    }, [])

    return (
        <>
            <div className='container-fluid'>
                <div className='scnd-header'>
                    <span className='icon1'>Masters / </span>
                    <span className='icon2'>User List</span>
                </div>

                {loading ?
                    <div className='wrapper-admin'>
                        <div className='text-center mb-3'>
                            <PropagateLoader
                                color="#2262C6"
                                size={20}
                            />
                        </div>
                    </div>
                    :
                    <DataTables
                        rowData={data}
                        columnDefs={columnDefs}
                    />
                }
            </div>

            <div className={groupList ? 'modal fade show d-block' : 'modal fade show d-none'} style={{ background: 'rgba(0,0,0,0.8)' }} >

                <div className="modal-dialog modal-lg modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Group List</h5>
                            <button type="button" className="btn-close" aria-label="Close" style={{ boxShadow: 'none' }} onClick={() => setGroupList(false)}></button>
                        </div>

                        <div className="modal-body">
                            {modalLoading ?
                                <div className='text-center mb-3'>
                                    <PropagateLoader
                                        color="#2262C6"
                                        size={20}
                                    />
                                </div>
                                :
                                <>
                                    {group_data && group_data.length ?
                                        <table className="table table-striped">
                                            <thead>
                                                <tr>
                                                    <th scope="col">SERIAL</th>
                                                    <th scope="col">GROUP NAME</th>
                                                    <th scope="col">STATUS</th>
                                                    <th scope="col">CREATED ON</th>
                                                </tr>
                                            </thead>
                                            <tbody className="table-group-divider">
                                                {group_data && group_data.map((value, index) =>
                                                    <tr key={index} style={{ verticalAlign: 'initial' }}>
                                                        <th scope="row">{index + 1}</th>
                                                        <td>{value.group_name}</td>
                                                        <td style={{ textTransform: 'capitalize', fontWeight: 'inherit' }}>
                                                            <span className={value.status == 'active' ? "badge text-bg-success" : "badge text-bg-danger"}>{value.status}</span>
                                                        </td>
                                                        {/* className={value.status == 'active' ? "badge text-bg-success" : "badge text-bg-danger"} */}
                                                        <td>{value?.createdAt && moment(value?.createdAt).format('DD/MM/YYYY')}</td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                        :
                                        <div className='text-center'>
                                            <span>No Group Found</span>
                                        </div>
                                    }
                                </>
                            }
                        </div>
                        {/* <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                            <button type="submit" className="btn btn_submit">Update</button>
                        </div> */}


                    </div>
                </div>
            </div >
        </>
    );
}